import styled from 'react-emotion';

export const SpinCanvas = styled('canvas')`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  display: ${props => (props.hide ? 'none' : 'block')};
`;

export const SpinWrapper = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;
`;
